import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getActivityListConfig } from "@/api/gmtool/packageCode";
import listviewfileActivities from './components/listviewfileActivities';
import { gmTool } from "@/mixins/index";
import activities from "./mixins/activities";
export default {
  name: "listActivities",
  mixins: [gmTool, activities],
  components: {
    listviewfileActivities: listviewfileActivities
  },
  data: function data() {
    return {
      tableData: []
    };
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.$bus.$on("DiList", function () {
                _this.getList(_this.paramsData.page);
              });

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    editingDi: function editingDi(row) {
      this.lodclickOperationLog('update-disposition-activity', this.$t('clickModifyConfigRecordBtn'));
      this.$emit("editingDi", row);
    },
    switchProd: function switchProd() {
      this.tableData = [];
    },
    getList: function getList(e) {
      var _this2 = this;

      this.paramsData.page = e;
      this.reqLoading = true;
      getActivityListConfig(this.paramsData).then(function (res) {
        if (res.status == 200) {
          _this2.tableData = res.data.data;
          _this2.total = res.data.total;
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    handleDelete: function handleDelete(row) {
      var _this3 = this;

      this.lodclickOperationLog('del-activity', this.$t('clickDeleteActivityBtn'));
      this.$confirm(this.$t('confirmDelete'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                delActivityList({
                  id: row.id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this3.getList(_this3.paramsData.page);

                    _this3.$message({
                      type: "success",
                      message: _this3.$t('deleteSuccess')
                    });
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    }
  }
};